import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-one-col-carousel-text',
  templateUrl: './one-col-carousel-text.component.html',
  styleUrls: ['./one-col-carousel-text.component.css']
})
export class OneColCarouselTextComponent implements OnInit {

  @Input() oneColCarouselText_items: any[] = []

  constructor() { }

  ngOnInit(): void {
  }

}
